import * as React from 'react'
import type {SVGProps} from 'react'
const SvgIconLoyalty3StepRedeem = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={74} height={74} viewBox="0 0 74 74" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                stroke="#142745"
                strokeWidth={2.658}
                d="M24.488 2c12.418 0 22.487 10.068 22.487 22.487a22.4 22.4 0 0 1-5.73 14.996l-.758-1.043a2.624 2.624 0 0 0-4.244 3.085l1.053 1.448a22.4 22.4 0 0 1-12.808 4.002C12.067 46.975 2 36.906 2 24.487 2 12.067 12.067 2 24.488 2Z"
            />
            <path
                fill="#E9F2FF"
                d="m24.874 14.819 2.745 6.657c.173.417.565.703 1.015.738l7.18.553c1.066.083 1.499 1.413.684 2.106l-5.482 4.668a1.2 1.2 0 0 0-.388 1.192l1.692 7c.251 1.039-.881 1.862-1.791 1.302l-6.135-3.773a1.2 1.2 0 0 0-1.254 0l-6.134 3.773c-.91.56-2.043-.263-1.792-1.302l1.694-7c.105-.438-.045-.9-.389-1.192l-5.483-4.668c-.813-.693-.381-2.023.685-2.106l7.179-.553c.45-.035.843-.32 1.015-.738l2.746-6.657c.407-.989 1.806-.989 2.213 0"
            />
            <path
                fill="#142745"
                d="m26.623 11.94 2.745 6.656c.172.418.564.703 1.015.738l7.18.554c1.066.082 1.498 1.412.683 2.105l-5.482 4.668a1.2 1.2 0 0 0-.388 1.193l1.692 7c.251 1.038-.881 1.86-1.791 1.302l-6.135-3.773a1.2 1.2 0 0 0-1.254 0l-6.133 3.773c-.911.559-2.043-.264-1.792-1.302l1.693-7c.106-.439-.045-.9-.389-1.193l-5.482-4.668c-.814-.693-.382-2.023.684-2.105l7.18-.554c.45-.035.842-.32 1.014-.738l2.746-6.657c.407-.988 1.806-.988 2.214 0"
            />
            <path
                stroke="#142745"
                strokeLinecap="round"
                strokeWidth={2.658}
                d="m48.136 57.885-11.893-16.36a2.623 2.623 0 0 1 4.244-3.085l8.334 11.466M53.395 47.367l-4.057-5.58a2.62 2.62 0 0 0-4.103-.173M58.404 45.409l-3.298-4.538a2.624 2.624 0 0 0-3.664-.58c-.18.132-.333.286-.469.449"
            />
            <path
                stroke="#142745"
                strokeLinecap="round"
                strokeWidth={2.658}
                d="M45.217 53.87s-2.587 1.142-2.168 3.743c.421 2.602 3.95 5.914 6.196 7.911s4.719 3.335 7.757 3.805c1.35.209 1.854.406 3.318 2.671M56.606 39.744a2.62 2.62 0 0 1 3.204.847l4.875 6.707c3.537 4.958 5.33 7.066 5.323 12.063-.002 1.177-.1 1.584 1.992 4.02"
            />
        </g>
    </svg>
)
export default SvgIconLoyalty3StepRedeem
